module.exports = __webpack_public_path__ + "static/img/beans-off.eb772005.png";